import type { BrandConfig } from './types';
export const briadConfig: BrandConfig = {
  key: 'blnyc',
  isDefault: false,
  subdomain: 'blnyc',
  logo: '/brands/amai/logo.png',
  title: '界墨AI - 领先的AI模型与创作者社区',
  siteName: 'AME AI',
  hiddenSidebarItems: ['invite'],
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'AME平台付费服务协议',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'AME平台付费协议' },
    { key: 'ricegrain-rules', label: '米粒值规则说明' },
    { key: 'privacy-policy', label: '用户协议及隐私政策' },
    { key: 'enterprise-service-agreement', label: '企业服务协议' },
  ],
  logoDisplay: {
    mode: 'text',
    showGlow: true,
    textStyle: { fontSize: '18px', fontWeight: '500' },
  },
};
